module.exports = __webpack_public_path__ + "static/img/sp1.92bfd5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sp1.png
// module id = giH+
// module chunks = 3